export default __webpack_public_path__ + "static/media/login.d98043c7.png";